export default __webpack_public_path__ + "static/media/trust-statement-report.a3f45386.svg";